import React, { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import EventCard from "@/components/EventCard";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { getWithRetry } from "@/lib/api";
import { IMAGES } from "@/lib/content";

export default function Events() {
  const [tab, setTab] = useState("upcoming");
  const [events, setEvents] = useState([]);

  useEffect(() => {
    getWithRetry(`/events?status=${tab}`).then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, [tab]);

  return (
    <>
      <Seo title="Events & Live DJs in Washington DC" description="Upcoming events at ChiCha Lounge DC — Social Saturdays, Fight Nights, Sunday Brunch, live DJs and VIP nightlife on U Street." path="/events" image={IMAGES.crowd} />
      <PageHero overline="What's On" title="Events & Nightlife" subtitle="Live DJs, fight nights, bottomless brunch and VIP celebrations — every week on U Street." image={IMAGES.crowd} />

      <section className="pb-28 bg-transparent">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="flex gap-3 mb-12">
            {["upcoming", "past"].map((t) => (
              <button
                key={t}
                data-testid={`events-tab-${t}`}
                onClick={() => setTab(t)}
                className={`px-6 py-2.5 rounded-full text-sm uppercase tracking-wide transition-all ${tab === t ? "bg-neutral-900 text-white" : "glass text-neutral-600"}`}
              >
                {t === "upcoming" ? "Upcoming" : "Past Events"}
              </button>
            ))}
          </div>

          {events.length === 0 ? (
            <p className="text-neutral-400 py-20 text-center">No {tab} events right now. Check back soon.</p>
          ) : (
            <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {events.map((ev, i) => (
                <StaggerItem key={ev.id}><EventCard ev={ev} showCountdown={tab === "upcoming" && i === 0} /></StaggerItem>
              ))}
            </Stagger>
          )}
        </div>
      </section>
    </>
  );
}
